/*
 * Represents the properties needed by React Grid Layout
 * - Settings could either be Text or a Timetable (Set Timetable, Instructor Timetable or Room Timetable)
 */
export class RGL {
    i: string;
    x: any;
    y: any;
    w: any;
    h: any;
    static: any;
    settings: any;

    constructor(i, x, y, w, h, settings) {
        this.i = String(i);
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
        this.static = settings.type !== 'timetable';
        this.settings = settings; //{ type, value: timetable}
    }
}
